{
  class NutritionDialog extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('a, button');
      this.dialog = this.querySelector('dialog');
      this.closeBtn = this.querySelector('.nutrition-dialog__close');

      if (!this.button || !this.dialog) return;

      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.dialog.showModal();
      });

      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) {
          this.dialog.close();
        }
      });

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => {
          this.dialog.close();
        });
      }
    }
  }

  if (!customElements.get('nutrition-dialog')) {
    customElements.define('nutrition-dialog', NutritionDialog);
  }
}
